import { ExternalLink, Copy, PackageCheck, Truck, Ban, NotepadTextDashed, ShieldX, CircleAlert, PackageX, HandPlatter, BaggageClaim, Lollipop } from "lucide-react";
import { showToast } from "../components/Toast";
import { countryOptions } from "../helpers/country_helper";

const TrackingColumnPrTest = ({ tableData, option }) => {
  let newData = tableData.delInfo ? tableData.delInfo : tableData;
  // console.log(newData)
  // Ensure trackingNo is always an array
  const trackingRaw = newData?.trackingNo ?? "";
  const trackingNumbers = Array.isArray(trackingRaw)
    ? trackingRaw
    : String(trackingRaw)
        .split(/[, .]+/)
        .filter(Boolean);

  // Prepare country text array based on trackingInfo's countryFrom and countryTo
  const countryTextArray = trackingNumbers.map((tn) => {
    const info = newData.trackingInfo?.[tn];
    if (!info) return null;

    // Convert country codes to full text using your helper
    const fromCountry = countryOptions.find((c) => c.value.toLowerCase() === (info.countryFrom || "").toLowerCase())?.text || info.countryFrom || "";
    const toCountry = countryOptions.find((c) => c.value.toLowerCase() === (info.countryTo || "").toLowerCase())?.text || info.countryTo || "";

    return fromCountry && toCountry ? `${fromCountry} to ${toCountry}` : null;
  });

  return trackingNumbers.length ? (
    <div className="d-flex align-items-center">
      <div>
        {trackingNumbers.map((trackingNumber, index) => {
          // Get status from trackingInfo or fallback
          const info = newData.trackingInfo?.[trackingNumber];
          let status = info?.status || "Getting Information";
          if (tableData?.delivered === true) {
            status = "Delivered";
          }
          const carrierNotRecognized = info?.carrierNotRecognized === true && tableData?.delivered !== true;
          // Choose icon based on status
          const IconComponent = status.includes("Delivered") ? (
            <PackageCheck size={18} className="text-success ms-2" />
          ) : status.includes("Transit") ? (
            <Truck size={18} className="text-info ms-2" />
          ) : status.includes("Failure") ? (
            <Ban size={18} className="text-danger ms-2" />
          ) : status.includes("Information") ? (
            <NotepadTextDashed size={18} className="text-info ms-2" />
          ) : status.includes("Not Found") ? (
            <Lollipop size={18} className="text-warning ms-2" />
          ) : status.includes("Pick Up") ? (
            <BaggageClaim size={18} className="text-info ms-2" />
          ) : status.includes("Out for Delivery") ? (
            <HandPlatter size={18} className="text-info ms-2" />
          ) : status.includes("Undelivered") ? (
            <PackageX size={18} className="text-danger ms-2" />
          ) : status.includes("Alert") ? (
            <CircleAlert size={18} className="text-warning ms-2" />
          ) : status.includes("Expired") ? (
            <ShieldX size={18} className="text-danger ms-2" />
          ) : null;

          return (
            <div key={index}>
              {/* Show country from-to if option is 'transfer' */}
              {option === "transfer" && countryTextArray[index] && (
                <div className="make-text-bold mb-1">
                  <strong>{countryTextArray[index]}</strong>
                </div>
              )}

              <h5 className="font-size-16 mb-1 d-flex align-items-center">
                <span className="d-inline-flex align-items-center">
                  <strong>{trackingNumber}</strong>
                  <a
                    href={info?.carrier ? `https://t.17track.net/en#nums=${trackingNumber}&fc=${info.carrier}` : `https://t.17track.net/en#nums=${trackingNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ms-1 d-flex align-items-center"
                  >
                    <ExternalLink size={16} />
                  </a>
                </span>
                &nbsp;{IconComponent}
                <span className="ms-2 status-text">{status}</span>
              </h5>
              {carrierNotRecognized && (
                <div
                  className="d-flex align-items-center mb-1"
                  style={{
                    color: "#d97706",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                  title="The carrier could not be detected automatically. 17TRACK will still try to identify the shipment."
                >
                  <CircleAlert size={15} className="me-1" />
                  Carrier not recognized
                </div>
              )}

              {/* Optional: Show daysOfTransit if available */}
              {info?.daysOfTransit !== undefined && info.daysOfTransit !== null && <small className="text-muted">Days in transit: {info.daysOfTransit}</small>}
            </div>
          );
        })}
      </div>

      {trackingNumbers.length > 0 && (
        <div className="ms-3">
          <Copy
            size={18}
            color="#497ea7"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();

              const textToCopy = trackingNumbers.join(",\n");
              const textarea = document.createElement("textarea");
              textarea.value = textToCopy;
              textarea.style.position = "fixed";
              textarea.style.opacity = 0;
              document.body.appendChild(textarea);
              textarea.select();

              try {
                if (document.execCommand("copy")) {
                  showToast("success", "Copied to clipboard");
                } else {
                  showToast("error", "Failed to copy tracking numbers.");
                }
              } catch {
                showToast("error", "Failed to copy tracking numbers.");
              }

              document.body.removeChild(textarea);
            }}
          />
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};

export default TrackingColumnPrTest;
